
import localization from '~/mixins/localization'

export default {
  mixins: [localization],

  props: {
    value: {
      type: null,
      required: true,
    },

    rules: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    instructions: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'text',
    },

    placeholder: {
      type: String,
      default: '',
    },

    autofocus: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedFiles: [],
    }
  },

  computed: {
    maxFilesCounter() {
      const pattern = /max:(\d+)/
      const match = this.rules.match(pattern)
      if (match) {
        return parseInt(match[1])
      }

      return 1
    },

    composedRules() {
      if (!this.rules) {
        return ''
      }

      let rules = this.rules.replace(/max:(\d+)/, '')

      if (rules.includes('image')) {
        rules = rules.replace('image', 'ext:jpg,jpeg,png,svg|size:2000')
      }

      return rules.replace('||', '|').replace(/^\|/, '').replace(/\|$/, '')
    },
  },

  mounted() {
    if (this.autofocus) {
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    }
  },

  methods: {
    onInput(e) {
      const fileList = e.target.files

      for (let i = 0; i < fileList.length; i++) {
        this.selectedFiles.push(fileList[i])
      }

      // convert FileList to Array
      const files = Array.from(e.target.files)
      this.$emit('input', files)
    },

    removeFileFromFileList(index) {
      this.selectedFiles.splice(index, 1)

      this.$emit('input', this.selectedFiles)
    },
  },
}
